import Icon from "../../../icon";
import Button from "../../../button";
import Popup from "../../index";
import React from "react";
import {useDispatch} from "react-redux";
import {
    isFreeEditionLabelContactLimitReachedPopupShown,
} from "../../../../../actions/popupActions";
import {useTranslation} from "react-i18next";
import {postEngagement} from '../../../../../actions/engagementActions';

function FreeEditionLabelContactLimitReachedPopup () {

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(isFreeEditionLabelContactLimitReachedPopupShown(false));
    };

	const handleUpgrade = () => {
		dispatch(postEngagement(59, new Intl.DateTimeFormat('fr-FR', {
			day: '2-digit',
			month: '2-digit',
			year: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
		}).format()));

		handleClose();
	};

    return (
        <Popup className="p-4" onClose={ handleClose }>
            <div>
                <h2 className="text-danger"><Icon name="minus-circle"/> {t('freeEditionLabelContactLimitReachedPopupTitle')}</h2>
                <p>{t('freeEditionLabelContactLimitReachedPopupContent')}</p>
                <div className="mt-3 text-right">
                    <Button onClick={ handleUpgrade } className="btn-primary">{t("upgradeToBusinessBtn")}</Button>
                </div>
            </div>
        </Popup>
    )
}

export default FreeEditionLabelContactLimitReachedPopup;
